import type { ApiOperationErrorContext } from "../apiRequestOptions";
import type { FormattedError } from "./userFacingErrors";
import { resolveUserFacingError } from "./userFacingErrors";

export function logUnknownErrorToConsole(
  err: unknown,
  label = "Frontend error",
): void {
  console.error(label, err);
}

/**
 * Best-effort formatting for errors coming from:
 * - Apollo (`ApolloError`, GraphQL errors, network errors)
 * - Atom framework JSON-encoded permission errors
 * - plain thrown Errors
 */
export function formatUnknownError(
  err: unknown,
  options?: {
    defaultMessage?: string;
    keyPrefix?: string;
    operationContext?: ApiOperationErrorContext;
  },
): FormattedError {
  return resolveUserFacingError(err, options);
}
